var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5229 2 12C2 6.47716 6.47715 2 12 2C17.5228 2 22 6.47716 22 12ZM9.22689 10.3193H7.16807V17H9.22689V10.3193ZM9.43697 8.21849C9.43697 8.89076 8.89076 9.43698 8.21849 9.43698C7.54622 9.43698 7 8.89076 7 8.21849C7 7.54622 7.54622 7 8.21849 7C8.89076 7 9.43697 7.54622 9.43697 8.21849ZM13.8067 11.958C12.9664 11.958 12.5462 12.5462 12.5462 13.4706V17H10.5714V10.3193H12.5462V11.2017C12.5462 11.2017 13.1345 10.1092 14.563 10.1092C15.9916 10.1092 17 10.9916 17 12.7563V16.958H14.9412V13.4706C14.9412 12.5042 14.563 11.958 13.8067 11.958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.baaa6802c5808800a1725bda39e34c7e.svg";
export { ForwardRef as ReactComponent };